module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_40",
      "title": "40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1958")])])]), _vm._v(" "), _c('p', {
    staticClass: "LHF"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OVEL")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SP"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Big Time,")]), _vm._v(" by Fritz Leiber")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("None")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("The 1958 Hugo Awards were awarded at Solacon in South Gate (Los Angeles), and they still didn’t announce nominees.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Best Novel Hugo was Fritz Leiber’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Big Time,")]), _vm._v(" which was an interesting choice. It’s in print, it has an ebook edition and an audio edition, and it’s available in the library but only in French. It’s a very short book about a time travelers’ war, and it introduced many of the tropes of time travel. It’s a very good book, and I like it, but although it’s in print, I don’t hear it talked about much, and I think Leiber isn’t such a big name as he once was. He’s best known now for his sword and sorcery, though he was prolific and wrote in almost every subgenre.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Hugo was the only genre award given in 1958—in our award-filled times, it’s a little hard to imagine. It’s also hard to be sure what else the fans of 1958 might have been considering.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Plausible nominees: Ayn Rand’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Atlas Shrugged,")]), _vm._v(" Jack Vance’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Big Planet,")]), _vm._v(" Philip K. Dick’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Cosmic Puppets")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Eye in the Sky,")]), _vm._v(" Ray Bradbury’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dandelion Wine,")]), _vm._v(" Arthur C. Clarke’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Deep Range,")]), _vm._v(" Robert Heinlein’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Door into Summer")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Citizen of the Galaxy,")]), _vm._v(" Fred Hoyle’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Black Cloud,")]), _vm._v(" Van Vogt’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Empire of the Atom,")]), _vm._v(" Philip Jos"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v(" Farmer’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Green Odyssey,")]), _vm._v(" Wyndham’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Midwich Cuckoos,")]), _vm._v(" Nevil Shute’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("On the Beach,")]), _vm._v(" Frederic Brown’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue in Space,")]), _vm._v(" and Eric Frank Russell’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Wasp.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_41",
      "title": "41"
    }
  }, [_vm._v("Again, I could make “Jo’s top five books of 1957” or “what I think would have been likely to be on the list” (and they’d be very different), but that’s fairly useless. I think it would be possible to make a case for any of this list as five likely nominees. Lots of these books are still read and widely debated—perhaps more so than "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Big Time.")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("THER")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ATEGORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("HORT")]), _vm._v(" S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("TORY")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" “Or All the Seas with Oysters,” by Avram Davidson ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Galaxy,")]), _vm._v(" May 1958)")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("Great choice, terrific classic unforgettable story. And from "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Galaxy.")]), _vm._v(" But from 1958, what’s going on here? What’s going on is that eligibility wasn’t by calendar year but from Worldcon to Worldcon, or something of the kind. They didn’t get this sorted for some time.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("O"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("UTSTANDING")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OVIE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Incredible Shrinking Man")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AGAZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("F&SF,")]), _vm._v(" edited by Anthony Boucher")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("My goodness. Was Campbell surprised?")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("O"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("UTSTANDING")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RTIST")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" Frank Kelly Freas")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v(" … again. We’ve had only six years of Hugos, and already we’re seeing repetition.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_42",
      "title": "42"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("UTSTANDING")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CTIFAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" Walter A. Willis")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("Yay! But note that this is a person award, not a fanzine award. These categories may look a lot more normal, but they are still in flux.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OMMENTS ON")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1958")])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("15. R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OB")]), _vm._v(" T.")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Leiber’s impact as a writer is somewhat diffuse not only because it was spread over several genres but also because this impact often came ahead of its time. Not only did the first Fafhrd and the Gray Mouser stories appear long before adventure fantasy became a marketable genre, but Leiber’s seminal urban horror stories “The Automatic Pistol” and “Smoke Ghost”—which speculated on how supernatural or uncanny forces might manifest themselves in a modern technological setting—appeared decades before horror became a marketable genre, as well. Leiber was also one of the first writers in American SF to propose (in “Coming Attraction” and later stories) that high technology and cultural decadence weren’t necessarily incompatible—that being surrounded by monuments of human rationality didn’t mean human irrationality was just going to disappear. (Alfred Bester and Cyril Kornbluth made similar breakthroughs around the same time.)")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Another factor that makes Leiber difficult to market is that not one of his novels is very much like any of the others, and most of the best are culminations or reworkings of themes from his short fiction. Thus we have "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Big Time")]), _vm._v(" from the Changewar series and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Swords of Lankhmar")]), _vm._v(" from the F&M series; "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Conjure Wife")]), _vm._v(" fits in with Leiber’s early horror stories, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Green Millennium")]), _vm._v(" among his early stories of technological decadence, and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Our Lady of Darkness")]), _vm._v(" among Leiber’s remarkable late series of autobiographical/roman "), _c('span', {
    staticClass: "accent"
  }, [_vm._v("à")]), _vm._v(" clef fantasies. (Shorter examples include “Catch That Zeppelin!,” “Horrible Imaginings,” and my personal favorite, “The Button Molder.”)")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_43",
      "title": "43"
    }
  }, [_vm._v("The uniqueness of each of Leiber’s novels means they don’t play off one another as readily as those of novelists more inclined to stick to particular themes or types of stories. Leiber would probably benefit as much as Theodore Sturgeon from a comprehensive, chronological series of his short fiction (perhaps leaving out the F&M stories, which don’t need the help).")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22e4cf0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 90
// module chunks = 0